import { render, staticRenderFns } from "./MarketBuzz.vue?vue&type=template&id=234ec0b2&"
import script from "./MarketBuzz.vue?vue&type=script&lang=js&"
export * from "./MarketBuzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports